import { convertUtcToLocal,convertUtcToLocalWithSeconds } from "../../utils/functions";

export const adminColumns = [
    {
      // 1. Date (Optional to sort by date, default is from new to old) [timestamp] - split
      Header: "Date",
      accessor: "",
      sort: false,
      //Cell: ({ row }: any) => `${row.original.timestamp.split("T")[0]}`,
      Cell: ({ row }: any) =>
      `${convertUtcToLocal(row.original.timestamp,'DD/MM/YYYY')}`,
    }, 
    {
      // 2. Time (Optional to sort by time, default is from new to old) [timestamp] - split
      Header: "Time",
      accessor: "",
      sort: false,
      //Cell: ({ row }: any) => `${row.original.timestamp.split("T")[1]}`,
      Cell: ({ row }: any) =>
      `${convertUtcToLocalWithSeconds(row.original.timestamp,'HH:mm:ss:SSS')}`,
    },
    {
      // 3. Event Type [type] - callback or test type
      Header: "Event Type",
      accessor: "type",
      sort: false,
    },
    {
      Header:"Campaign Name",
      accessor:"camp_name",
      sort:false
    },
    { 
      Header: "Campaign Status",
      accessor: "remark",
      sort: false,
    },
    { 
      Header: "USER",
      accessor: "user",
      sort: false,
    },
    { 
      Header: "USER_ID",
      accessor: "user_id",
      sort: false,
    },
    { 
      Header: "BUNDLE",
      accessor: "bundle",
      sort: false,
    },
    { 
      Header: "DOMAIN",
      accessor: "domain",
      sort: false,
    },
    { 
      Header: "USER_SHA1",
      accessor: "user_sha1",
      sort: false,
    },
    {
      Header:"Auction ID",
      accessor:"ai",
      sort:false
    },
    {
      Header:"Bid Time",
      accessor:"bt",
      sort:false
    },
    { 
      Header: "CAMP_ID",
      accessor: "camp_id",
      sort: false,
    },
    {
      Header: "IP",
      accessor: "ip",
      sort: false,
    },
    { 
      Header: "EXC",
      accessor: "exc",
      sort: false,
    },
    // {
    //   // 4. URL [url]
    //   Header: "URL",
    //   accessor: "url",
    //   sort: false,
    //   Cell: ({ row }: any) =>
    //   `${decodeURI(row.original.url)}`,
    // },
    {
     
      Header: "Concat IP",
      accessor: "concat",
      sort: false,
    },
    {
      // 6. Referrer [referrer]
      Header: "Referrer",
      accessor: "referrer",
      sort: false,
    },
    {
      // 7. Client Type [clientType]
      Header: "Client Type",
      accessor: "clientType",
      sort: false,
    },
    {
      // 8. Client Name [clientName]
      Header: "Client Name",
      accessor: "clientName",
      sort: false,
    },
    { 
      Header: "Browser",
      accessor: "browser",
      sort: false,
    },
    {
      // 9. Device Type [devicetype]
      Header: "Device Type",
      accessor: "deviceType",
      sort: false,
    },
    {
      // 10. Device Brand [deviceBrand]
      Header: "Device Brand",
      accessor: "deviceBrand",
      sort: false,
    },
    {
      // 11. Device Model [deviceModel]
      Header: "Device Model",
      accessor: "deviceModel",
      sort: false,
    },
    {
      // 12. OS Name [osName]
      Header: "OS Name",
      accessor: "osName",
      sort: false,
    },
    {
      // 13. OS Version [osVersion]
      Header: "OS Version",
      accessor: "osVersion",
      sort: false,
    },
    {
      // 14. userAgent [userAgent]
      Header: "User Agent",
      accessor: "userAgent",
      sort: false,
    },
    {
      Header: "CB User IP",
      accessor: "userIP",
      sort: false,
    },
  ];

  export const commonColumns = [
    {
      // 1. Date (Optional to sort by date, default is from new to old) [timestamp] - split
      Header: "Date",
      accessor: "",
      sort: false,
      Cell: ({ row }: any) =>
      `${convertUtcToLocal(row.original.timestamp,'DD/MM/YYYY')}`,
    }, 
    {
      // 2. Time (Optional to sort by time, default is from new to old) [timestamp] - split
      Header: "Time",
      accessor: "",
      sort: false,
      Cell: ({ row }: any) =>
      `${convertUtcToLocalWithSeconds(row.original.timestamp,'HH:mm:ss:SSS')}`,
    },
    {
      // 3. Event Type [type] - callback or test type
      Header: "Event Type",
      accessor: "type",
      sort: false,
    },
    {
      Header:"Campaign Name",
      accessor:"camp_name",
      sort:false
    },
    { 
      Header: "Campaign Status",
      accessor: "remark",
      sort: false,
    },
    { 
      Header: "USER",
      accessor: "user",
      sort: false,
    },
    { 
      Header: "USER_ID",
      accessor: "user_id",
      sort: false,
    },
    { 
      Header: "BUNDLE",
      accessor: "bundle",
      sort: false,
    },
    { 
      Header: "DOMAIN",
      accessor: "domain",
      sort: false,
    },
    { 
      Header: "USER_SHA1",
      accessor: "user_sha1",
      sort: false,
    },
    { 
      Header: "CAMP_ID",
      accessor: "camp_id",
      sort: false,
    },
    {
      Header: "IP",
      accessor: "ip",
      sort: false,
    },
    // {
    //   // 4. URL [url]
    //   Header: "URL",
    //   accessor: "url",
    //   sort: false,
    //   Cell: ({ row }: any) =>
    //   `${decodeURI(row.original.url)}`,
    // },
    
    { 
      Header: "Browser",
      accessor: "browser",
      sort: false,
    },
    {
      // 9. Device Type [devicetype]
      Header: "Device Type",
      accessor: "deviceType",
      sort: false,
    },
    {
      // 10. Device Brand [deviceBrand]
      Header: "Device Brand",
      accessor: "deviceBrand",
      sort: false,
    },
    {
      // 11. Device Model [deviceModel]
      Header: "Device Model",
      accessor: "deviceModel",
      sort: false,
    },
    {
      // 12. OS Name [osName]
      Header: "OS Name",
      accessor: "osName",
      sort: false,
    },
    {
      // 13. OS Version [osVersion]
      Header: "OS Version",
      accessor: "osVersion",
      sort: false,
    },
    {
      // 14. userAgent [userAgent]
      Header: "User Agent",
      accessor: "userAgent",
      sort: false,
    },
    {
      // 5. URL [url]
      Header: "CB User IP",
      accessor: "userIP",
      sort: false,
    },
  ];